import { render, staticRenderFns } from "./WFCaseQueryConfigAdd.vue?vue&type=template&id=4c0c73b7&scoped=true"
import script from "./WFCaseQueryConfigAdd.vue?vue&type=script&lang=js"
export * from "./WFCaseQueryConfigAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0c73b7",
  null
  
)

export default component.exports